import React, { useContext } from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import CustomBorderedText from "@Components/CustomBorderedText"
import { arrayOfColors } from "@Constants/constant"
import { useNavigation, useRoute } from "@react-navigation/native"
import { QuizzContext } from "@Providers/QuizzProvider"

const CustomEvaluationItem = (props) => {
    const { item, setSelectedId } = props
    const navigation = useNavigation()
    const { setSelectedQuizz } = useContext(QuizzContext)
    const colorToUse = item?.hasReplied ? arrayOfColors[0] : arrayOfColors[1]
    const handlePress = () => {
        setSelectedId?.(item?.id)
        setSelectedQuizz(item)
        navigation.navigate("EvaluationQuizz", { isResult: item?.hasReplied })
    }

    return (
        <TouchableOpacity style={styles.container} onPress={handlePress}>
            <View style={{ flex: 1, flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <View style={{ flex: 1 }}>
                    <OpenSansText
                        style={{ color: baseColors.black }}
                        defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                        fontSize={14}
                    >
                        {item.title}
                    </OpenSansText>
                </View>

                {item?.hasReplied && (
                    <OpenSansText
                        style={{ color: baseColors.black }}
                        defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                        fontSize={20}
                    >
                        ✅
                    </OpenSansText>
                )}
            </View>
            <View style={styles.child}>
                <CustomBorderedText
                    label={item.subContent.title}
                    color={colorToUse.textColor}
                    backgroundColor={colorToUse.backgroundColor}
                />
            </View>
        </TouchableOpacity>
    )
}

export default CustomEvaluationItem
